// src/Project.jsx
import React, { useContext } from 'react';
import ScriptContext from './ScriptContext';

function Project(props) {
  const { projects, activeFilter } = useContext(ScriptContext);

  const label = "open-popup-" + props.year + "-" + props.name.replace(/\s/g, "-");
  const fqsrc = "/images/projects/" + props.year + "/" + props.name.replace(/\s/g, "%20") + "/" + props.src;

  // ✅ Register project immediately (synchronous, as before)
  if (projects) {
    const exists = projects.some(
      (el) => el.year === props.year && el.name === props.name
    );
    if (!exists) {
      projects.push({
        year: props.year,
        name: props.name,
        src: props.src,
        categories: props.categories,
        title: props.title,
        title2: props.title2,
        label: label,
        fqsrc: fqsrc,
        config: {
          fixedContentPos: true,
          items: [],
          gallery: { enabled: true },
          type: 'image'
        }
      });
    }
  }

  // ✅ Determine visibility based on activeFilter
  const isVisible =
    activeFilter === 'category-all' ||
    props.categories.split(' ').includes(activeFilter);

  const visibilityClass = isVisible ? '' : 'filtered-out';

  return (
    <div className={`mb-3 col-md-3 project-item filter ${props.categories} ${visibilityClass}`}>
      <a href="#top" id={label}>
        <img className="thumbnail img-fluid" src={fqsrc} alt="" />
        {props.children}
      </a>
      <div className="text-start mt-1">
        <strong>{props.title}</strong><br />
        {props.title2}
      </div>
    </div>
  );
}

export default Project;
